import React from 'react';

import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import classes from './styles.module.scss';

export default function CompanyStatus({ value }) {
  const { t } = useTranslation();

  return (
    <td className={classes.CompanyStatus}>
      <div
        className={classNames(classes.companyStatus, {
          [classes.green]: value === 'Active',
          [classes.purple]: value === 'Prospect',
          [classes.red]: value === 'Inactive',
        })}
      >
        {t(`common.status.${value}`)}
      </div>
    </td>
  );
}
